import { Component } from '@angular/core';
import BaseQuestion from '../base-question';
import { FeedbackQuestionService } from '../feedback-question.service';
import { FeedbackQuestion } from "../../../common/models/feedback-question";
import { FeedbackHurtAnswerComponent } from "../../answers/hurt";

@Component({
  selector: 'app-feedback-hurt-question',
  templateUrl: 'feedback-hurt-question.component.html',
  standalone: true,
  imports: [
    FeedbackHurtAnswerComponent
  ],
  styleUrls: ['./../feedback-question.css']
})
export class FeedbackHurtQuestionComponent extends BaseQuestion {
    public static type = FeedbackQuestion.TYPE_HURT;

    constructor(feedbackQuestionService: FeedbackQuestionService) {
        super(feedbackQuestionService);
    }
}
